import Rewind1 from "./Rewind1";
import Rewind2 from "./Rewind2";
import Rewind3 from "./Rewind3";
import Rewind4 from "./Rewind4";
import Rewind5 from "./Rewind5";
import Rewind6 from "./Rewind6";
import Rewind7 from "./Rewind7";
import Rewind8 from "./Rewind8";


const Icons = {
    Rewind1: Rewind1,
    Rewind2: Rewind2,
    Rewind3: Rewind3,
    Rewind4: Rewind4,
    Rewind5: Rewind5,
    Rewind6: Rewind6,
    Rewind7: Rewind7,
    Rewind8: Rewind8,
};

export const RewindIcons = [
    Rewind1, Rewind2, Rewind3, Rewind4, Rewind5, Rewind6, Rewind7, Rewind8
];

export default Icons;